import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from '../Link';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Logo.css';

class Logo extends Component {
  static propTypes = {
    link: PropTypes.string,
    className: PropTypes.string,
    logoHeight: PropTypes.string,
    logoWidth: PropTypes.string,
  };

  static defaultProps = {
    siteName: null,
    logoImage: null,
    link: '/',
    logoHeight: '63',
    logoWidth: '34',
  };

  render() {
    const { link, className, logoHeight, logoWidth } = this.props;
    return (
      <Link to={link} className={className}>
        <img
          src={'/images/logo/blueRaw.png'}
          height={logoHeight - 12}
          width="auto"
          style={{ padding: '6px' }}
        />
      </Link>
    );
  }
}

export default withStyles(s)(Logo);



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js